import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../../../store/reducers/rootReducer'
import { loadProblemTypes } from '../../../../../../store/actions/problemTypesActions'
import { IProblemListItem } from '../../../../../modules/API/TeudotProblems/models/problems'

export const useProblemTypes = () => {
  const dispatch = useDispatch()
  
  const problemTypes: IProblemListItem[] | null = useSelector(
    (state: RootState) => state.problemTypesReducer.problemTypes
  )
  
  const isLoading: boolean = useSelector(
    (state: RootState) => state.problemTypesReducer.isLoading
  )

  const loadProblems = () => {
    dispatch(loadProblemTypes() as any)
  }

  useEffect(() => {
    if (!problemTypes) {
      loadProblems()
    }
  }, [])

  return {
    problemTypes,
    isLoading,
    loadProblems
  }
} 